import { render, staticRenderFns } from "./NbMore.vue?vue&type=template&id=4c3c8fb4"
import script from "./NbMore.vue?vue&type=script&lang=js"
export * from "./NbMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports